<template>
    <div>
        <div class="color-picker-heading">
            <h3>Choose Color</h3>
            <a
                v-if="showSeeSpecs"
                v-scroll-to="'#key-features'"
                class="color-picker_scroll"
                @click="$emit('see-specs')"
            >
                See Specs
            </a>
        </div>

        <div class="color-picker">
            <div
                v-for="variant in cases.variants"
                :key="`case-${variant.id}`"
                :class="{'selected': variant.id == cart.case.id, 'disable-element': isUpdating || variant.id == cart.case.id }"
                class="picker"
                @click="updatePc(variant)"
            >
                <div
                    :style="{ backgroundColor: variant.colors_code }"
                    class="circle"
                />
                {{ variant.colors }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "ColorPicker",
    props: {
        showSeeSpecs: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            cart: state => state.StarterPc.cart,
            cases: state => state.StarterPc.cases,
            isUpdating: state => state.StarterPc.isUpdating,
            motherboards: state => state.StarterPc.motherboards,
        })
    },
    methods: {
        ...mapActions({
            updatePart: "StarterPc/updatePart"
        }),
        async updatePc(variant) {
            await this.updatePart({ part: variant, qty: 1 });
            this.updateColor();
        },
        updateColor()  {
            if (this.$route.name.includes('creator-pc')) {
                const caseColor = this.cart.case.colors && this.cart.case.colors.toLowerCase() || "";
                const motherboardColor = this.cart.motherboard.colors && this.cart.motherboard.colors.toLowerCase() || "";

                if (caseColor != motherboardColor) {
                    const motherboardVariant = this.motherboards.find((motherboard) => {
                        const variantColor = motherboard.colors && motherboard.colors.toLowerCase() || "";
                        return variantColor == caseColor
                    });

                    this.updatePart({
                        part: {
                            products_id: motherboardVariant.products_id,
                            id: motherboardVariant.id
                        },
                        qty: 1
                    });
                }

            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.color-picker_scroll{
    cursor: pointer;
}

.color-picker-heading {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    h3 {
        text-transform: uppercase;
        margin: 0;

        @media (max-width: 580px) {
            font-size: 20px;
        }
    }

    a {
        font-size: 16px;
        color: $orchid;

        @media (max-width: 580px) {
            font-size: 14px;
        }
    }
}

.color-picker {
    display: flex;
    margin-top: 12px;

    @media (max-width: 991px) {
        margin-top: 0;
    }

    .picker {
        height: 64px;
        width: 50%;
        padding: 10px 18px;
        border: 3px solid rgba(#dadde0, 0.6);
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s;

        &:first-child {
            margin-right: 16px;
        }

        &:hover {
            border: 3px solid $orchid;
            color: $orchid;
        }

        .circle {
            height: 30px;
            width: 30px;
            border-radius: 50%;
            margin-right: 10px;
            border: 2px solid rgba(218, 221, 224, 0.6);
        }
    }

    .selected {
        border: 3px solid $orchid;
        color: $orchid;
    }
}
</style>
